import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class MarvHistoryService {

    oldState: any;
    originalPushState: any;
    originalBack: any;
    
    constructor(
        private modalController: ModalController
    ) {}
    
    init(){
        this.originalPushState = window.history.pushState;        
        this.originalBack = window.history.back;        
        window.history.pushState = (data: any, unused: string, url?: string | URL | null) => {this.pushState(data, unused, url)};
        window.onpopstate = (event: any) => {this.onPopstate(event)};
    }
    
    pushState(data: any, unused: string, url?: string | URL | null) {
        this.oldState = data;
        this.originalPushState.call(window.history, data, unused, url);
    }
    
    popState(){        
        this.oldState = null;
        this.originalBack.call(window.history);
    }

    async onPopstate (event: any) {       
        if(this.oldState?.modal === true){            
            let modal = await this.modalController.getTop();
            if (modal) {
                this.modalController.dismiss({resetDrawer: true, backButton: true});             
            }    
        }
        this.oldState = event.state;
    }
}
